import {
  GET_ACTION_PLAN_CATEGORIES, GET_ACTION_PLAN_CATEGORIES_SUCCESS, GET_ACTION_PLAN_CATEGORIES_FAIL,
  GET_ACTION_PLANS, GET_ACTION_PLANS_SUCCESS, GET_ACTION_PLANS_FAIL,
  GET_ALL_ACTION_PLANS, GET_ALL_ACTION_PLANS_SUCCESS, GET_ALL_ACTION_PLANS_FAIL,
  GET_ACTION_PLAN_DETAIL, GET_ACTION_PLAN_DETAIL_SUCCESS, GET_ACTION_PLAN_DETAIL_FAIL, CLEAR_ACTION_PLAN_DETAIL,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  categories: [],
  plans: [],
  allPlans: [],
  planDetail: null,
  detailLoading: false,
}

const ActionPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTION_PLAN_CATEGORIES:
      return { ...state, loading: true }
    case GET_ACTION_PLAN_CATEGORIES_SUCCESS:
      return { ...state, categories: action.payload || [], loading: false }
    case GET_ACTION_PLAN_CATEGORIES_FAIL:
      return { ...state, error: action.payload, loading: false }

    case GET_ACTION_PLANS:
      return { ...state, loading: true }
    case GET_ACTION_PLANS_SUCCESS:
      return { ...state, plans: action.payload || [], loading: false }
    case GET_ACTION_PLANS_FAIL:
      return { ...state, error: action.payload, loading: false }

    case GET_ALL_ACTION_PLANS:
      return { ...state, loading: true }
    case GET_ALL_ACTION_PLANS_SUCCESS:
      return { ...state, allPlans: action.payload || [], loading: false }
    case GET_ALL_ACTION_PLANS_FAIL:
      return { ...state, error: action.payload, loading: false }

    case GET_ACTION_PLAN_DETAIL:
      return { ...state, detailLoading: true }
    case GET_ACTION_PLAN_DETAIL_SUCCESS:
      return { ...state, planDetail: action.payload, detailLoading: false }
    case GET_ACTION_PLAN_DETAIL_FAIL:
      return { ...state, error: action.payload, detailLoading: false }
    case CLEAR_ACTION_PLAN_DETAIL:
      return { ...state, planDetail: null }

    default:
      return state
  }
}

export default ActionPlanReducer
